import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import { AccountingItem } from '~/app/accounting/accounting-page'
import { QUERY_KEYS } from '~/constants/react-query'

export const useAccountingUpdates = () => {
  const queryClient = useQueryClient()

  const updateMemo = useCallback(
    (transactionId: string, memo: string) => {
      const accountingQueries = queryClient.getQueriesData({
        queryKey: [QUERY_KEYS.ORG_ACCOUNTING_ITEMS],
      })

      accountingQueries.forEach(([queryKey]) => {
        queryClient.setQueryData(
          queryKey,
          (cachedItems: { items: AccountingItem[] }) => {
            const updatedItems = (cachedItems?.items ?? []).map((item) => {
              if (item.id === transactionId) {
                return {
                  ...item,
                  memo,
                }
              }
              return item
            })
            return { items: updatedItems }
          },
        )
      })
    },
    [queryClient],
  )

  return { updateMemo }
}
